import { Component, OnInit, Renderer2, OnDestroy, AfterViewInit, ElementRef } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { Validators } from "@angular/forms";
import { AuthService } from "../../service/auth-service/auth.service";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { sweetAlert } from "../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { SocketService } from "src/app/service/socket-service/socket-service.service";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { environment } from "src/environments/environment";
import { AssigTripsService } from "../assigned-trips/assigntrips-service/assigntrips-service";


@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.css"],
})
export class SignInComponent implements OnInit, OnDestroy {
  success: boolean;
  passwordToggleFlag = true;
  signInForm: UntypedFormGroup;
  submitted = false;
  isAdmin = false;
  isCompany = true;
  isShowToggler = false;
  fireworksCanvas: HTMLCanvasElement | null = null;
  fireworksInterval: any = null;
  fireworksAnimation: any = null;
  fireworksTimeout: any = null;

  // fireworks;

  constructor(
    private renderer: Renderer2,
    private fb: UntypedFormBuilder,
    private assignTripService: AssigTripsService,
    private authService: AuthService,
    private sharedDataService: SharedDataService,
    private socket: SocketService,
    private router: Router,
    private renderere: Renderer2,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    window.addEventListener("keyup", this.initializeTimer);
    this.signInForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
    });
  }

  randomInRange(min: number, max: number): number {
    return Math.random() * (max - min) + min;
  }

  initializeTimer = (e) => {
    if (
      e.altKey &&
      (e.key.toLowerCase() === "v" || e.key.toLowerCase() === "√")
    ) {
      this.isShowToggler = !this.isShowToggler;
      if (this.isShowToggler) {
        this.isAdmin = true;
        this.isCompany = false;
      } else {
        this.isCompany = true;
        this.isAdmin = false;
      }
    }
  };

  get form() {
    return this.signInForm.controls;
  }

  togglePasswordType() {
    this.passwordToggleFlag = !this.passwordToggleFlag;
  }

  onSignIn() {

    this.submitted = true;
    if (this.signInForm.invalid) {
      return;
    }

    let role;

    if (this.isAdmin) {
      role = 'admin';

    } else {
      if (this.isCompany) {
        role = 'company';
      } else {
        role = 'staff';
      }

    }



    this.authService
      .login(this.signInForm.value.email, this.signInForm.value.password, role)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.success) {
          this.authService.setToken(data.token);
          this.sharedDataService.saveUser(data.user);
          this.socket.connectSocket();
          this.router.navigateByUrl('/');
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    this.renderere.appendChild(document.body, script);
    return script;
  }

  changeAdminRole() {
    this.isAdmin = !this.isAdmin;
    this.isCompany = true;
  }



  // ngAfterViewInit() {
  //   this.applyFireworks();
  // }


applyFireworks() {
  this.fireworksCanvas = document.createElement('canvas');
  this.fireworksCanvas.style.position = 'fixed';
  this.fireworksCanvas.style.top = '0';
  this.fireworksCanvas.style.left = '0';
  this.fireworksCanvas.style.width = '100%';
  this.fireworksCanvas.style.height = '100%';
  this.fireworksCanvas.style.pointerEvents = 'none';
  this.fireworksCanvas.style.zIndex = '9999';
  document.body.appendChild(this.fireworksCanvas);

  const ctx = this.fireworksCanvas.getContext('2d')!;
  let canvasWidth = window.innerWidth;
  let canvasHeight = window.innerHeight;
  this.fireworksCanvas.width = canvasWidth;
  this.fireworksCanvas.height = canvasHeight;

  const rockets: Rocket[] = [];
  const particles: Particle[] = [];

  window.addEventListener('resize', () => {
    canvasWidth = window.innerWidth;
    canvasHeight = window.innerHeight;
    this.fireworksCanvas.width = canvasWidth;
    this.fireworksCanvas.height = canvasHeight;
  });

  const colorPalette = [
    '#FF3F3F', // red
    '#FFD93D', // yellow
    '#6A0DAD', // purple
    '#00FFFF', // cyan
    '#FF8C00', // orange
    '#FFFFFF'  // white
  ];

  class Rocket {
    x: number;
    y: number;
    vy: number;
    explodeY: number;
    color: string;
    trail: { x: number; y: number }[];

    constructor() {
      this.x = Math.random() * canvasWidth;
      this.y = canvasHeight;
      this.vy = -(Math.random() * 5 + 7);
      this.explodeY = Math.random() * (canvasHeight / 2) + 50;
      this.color = colorPalette[Math.floor(Math.random() * colorPalette.length)];
      this.trail = [];
    }

    update() {
      this.trail.push({ x: this.x, y: this.y });
      if (this.trail.length > 10) this.trail.shift();

      this.y += this.vy;
      this.vy += 0.05;

      this.draw();

      if (this.y <= this.explodeY) {
        this.explode();
        return true;
      }
      return false;
    }

    draw() {
      ctx.beginPath();
      for (let i = 0; i < this.trail.length; i++) {
        const p = this.trail[i];
        ctx.globalAlpha = i / this.trail.length;
        ctx.lineTo(p.x, p.y);
      }
      ctx.strokeStyle = this.color;
      ctx.lineWidth = 2.5;
      ctx.stroke();
      ctx.globalAlpha = 1;
    }

    explode() {
      const count = 60 + Math.random() * 40;
      for (let i = 0; i < count; i++) {
        particles.push(new Particle(this.x, this.y));
      }
    }
  }

  class Particle {
    x: number;
    y: number;
    vx: number;
    vy: number;
    life: number;
    color: string;

    constructor(x: number, y: number) {
      this.x = x;
      this.y = y;
      this.color = colorPalette[Math.floor(Math.random() * colorPalette.length)];
      const angle = Math.random() * 2 * Math.PI;
      const speed = Math.random() * 5 + 2;
      this.vx = Math.cos(angle) * speed;
      this.vy = Math.sin(angle) * speed;
      this.life = 80 + Math.random() * 40;
    }

    update() {
      this.vy += 0.03; // gravity
      this.x += this.vx;
      this.y += this.vy;
      this.life--;
      this.draw();
    }

    draw() {
      ctx.beginPath();
      ctx.moveTo(this.x, this.y);
      ctx.lineTo(this.x - this.vx, this.y - this.vy); // streak effect
      ctx.strokeStyle = this.color;
      ctx.globalAlpha = Math.max(this.life / 100, 0);
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.globalAlpha = 1;
    }
  }

  const animate = () => {
    ctx.clearRect(0, 0, canvasWidth, canvasHeight); // transparent background

    rockets.forEach((r, i) => {
      if (r.update()) rockets.splice(i, 1);
    });

    particles.forEach((p, i) => {
      p.update();
      if (p.life <= 0) particles.splice(i, 1);
    });

    this.fireworksAnimation = requestAnimationFrame(animate);
  };

  this.fireworksInterval = setInterval(() => {
    rockets.push(new Rocket());
    if (Math.random() < 0.2) rockets.push(new Rocket());
  }, 400);

  animate();

  this.fireworksTimeout = setTimeout(() => {
    this.stopFireworks();
  }, 30000);
}


stopFireworks() {
  if (this.fireworksInterval) {
    clearInterval(this.fireworksInterval);
    this.fireworksInterval = null;
  }

  if (this.fireworksAnimation) {
    clearInterval(this.fireworksAnimation);
    this.fireworksAnimation = null;
  }

  if (this.fireworksTimeout) {
    clearTimeout(this.fireworksTimeout);
    this.fireworksTimeout = null;
  }

  if (this.fireworksCanvas) {
    document.body.removeChild(this.fireworksCanvas);
    this.fireworksCanvas = null;
  }
}


  ngOnDestroy(): void {
    window.removeEventListener("keyup", this.initializeTimer);
    // this.fireworks.waitStop(true);
    //     if (this.snowTimeout) {
    //   clearTimeout(this.snowTimeout);
    // }

    // this.stopSnow();
  }
}
